import { getTeamsState } from '../selectors';

export const getTeamsListState = state => getTeamsState(state).list;
export const getTeams = state => getTeamsListState(state).data;
